import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ContactPage from './pages/ContactPage.js';
import HomePage from './pages/HomePage.js';
import NotFoundPage from './pages/NotFoundPage.js';
import ProjectsPage from './pages/ProjectsPage.js';
import DrillsPage from './pages/DrillsPage.js';
import ScrewsPage from './pages/ScrewsPage.js';
import FrameDesign from './FrameDesign/FrameDesign.jsx';
// import AboutPage from './pages/AboutPage.js';
// import FeedsPage from './pages/FeedsPage.js';
import CylFitsPage from './pages/CylFitsPage.js';

import Navbar from './Navbar/Navbar.js';
import Footer from './Footer.js';

const App = () => {
  return (
    <BrowserRouter>
      <div className="main-content">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/drills" element={<DrillsPage />} />
          <Route path="/screws" element={<ScrewsPage />} />
          <Route path="/frame" element={<FrameDesign />} />
          {/* <Route path="/about" element={<AboutPage />} /> */}
          {/* <Route path="/feeds" element={<FeedsPage />} /> */}
          <Route path="/cylfits" element={<CylFitsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
